<template>
	<div>
		<navigator :index="1"></navigator>
		<!-- <div class="navigationBg">
			<header class="navigation">
				<h1>
					<img class="logo" alt="筑橙科技" src="../resource/images/logo.svg">
				</h1>
				<nav class="navigator">
					<router-link to="/" class="navigatorText">首页
						<div class="block"></div>
					</router-link>
					<div @click="reminder()" class="navigatorText">产品中心
						<div class="block"></div>
					</div>
					<router-link to="/example01" class="navigatorText active">应用案例
						<div class="block activeBlock"></div>
					</router-link>
					<router-link to="/news01" class="navigatorText">筑橙新闻
						<div class="block"></div>
					</router-link>
					<router-link  to="/aboutUs" class="navigatorText">关于我们
						<div class="block"></div>
					</router-link>
					<div @click="open()" class="navigatorText">在线联系
						<div class="block"></div>
					</div>
				</nav>
			</header>
		</div> -->
		<div class="localhost">
			<div class="localhostText">首页/应用案例/<span style="color:#333;">建发·厦门文澜和著</span></div>
		</div>
		<div class="example">
			<div class="exampleTitle">建发·厦门文澜和著</div>
			<div class="exampleDate">2022年3月31日</div>
			<div class="exampleItemDiv">
				<div class="exampleItem">
					<h3 class="exampleItemTitle">筑橙科技与中建海峡建设发展有限公司在建发·厦门文澜和著项目高层业态开展合作，进行外墙涂料机器人喷涂工作。</h3>
					<div class="exampleImgList">
						<div class="exampleImg">
							<img style="width:100%:height:auto;" src="../resource/images/img15.png" alt="建发·厦门文澜和著">
							<div class="hint">项目鸟瞰图</div>
						</div>
					</div>
				</div>
				<div class="exampleItem">
					<div class="exampleItemTitle">5#楼为31层板楼，涂料体系为：真石漆。施工过程展示：</div>
					<div class="exampleImgList">
						<div class="exampleImg">
							<img style="width:100%:height:auto;" src="../resource/images/img16.png" alt="真石漆">
						</div>
					</div>
				</div>
				<div class="exampleItem">
					<div class="exampleItemTitle">完工效果展示：</div>
					<div class="exampleImgList">
						<div class="exampleImg">
							<img style="width:100%:height:auto;" src="../resource/images/img17.png" alt="山墙立面效果">
							<div class="hint">山墙立面效果</div>
						</div>
						<div class="exampleImg">
							<img style="width:100%:height:auto;" src="../resource/images/img18.png" alt="连廊立面效果">
							<div class="hint">连廊立面效果</div>
						</div>
					</div>
				</div>
			</div>
			<div class="line"></div>
			<article class="lastHint">
				筑橙科技致力于研发世界领先的建筑机器人，用机器人技术推动传统施工行业技术变革，为建筑施工产业提供智能施工解决方案。公司设有深圳、昆山两大研发中心，已在2021年实现外墙喷涂机器人的量产和产业化应用。
			</article>
			<div class="getMore">
				<div class="previous">上一个：没有更多啦~</div>
				<router-link to="/example02" class="next">下一个：瑞安金茂悦</router-link>
			</div>
		</div>
		<foot></foot>
	</div>
</template>

<script>
	import foot from "../components/foot"
	import navigator from "../components/navigator"
	export default {
		components: {
			foot,
			navigator
		},
		name: 'example01',
		data() {
			return {

			}
		},
		methods:{
			open(){
				window.open("http://qingflow.com/f/a445638c?qfchannel=Website")
				// window.location.href = "http://qingflow.com/f/a445638c?qfchannel=Website"
			},
			 reminder(){
				 this.hint.hint()
			 }
		}
	}
</script>

<style scoped>
	.line {
		width: 1045px;
		height: 2px;
		background-color:#194c7f;
		margin:49px auto 50px auto;
		border-radius: 2px;
	}

	.next {
		display: block;
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
		line-height: 12px;
		letter-spacing: 0.58px;
		margin-top: 10px;
		margin-bottom: 100px;
		transition: all .3s;
	}

	.previous {
		display: block;
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999999;
		line-height: 12px;
		letter-spacing: 0.58px;
	}

	.next:hover {
		color: #194c7f;
	}

	.lastHint {
		text-indent: 2em;
		margin: 50px auto;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		/* color: #707070; */
		color:#666;
		line-height: 26px;
		letter-spacing: 0.77px;
	}

	.exampleItemTitle {
		margin-top: 50px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #707070;
		line-height: 26px;
		letter-spacing: 0.77px;
		margin-bottom: 30px;
	}

	.hint {
		margin-top: 15px;
		line-height: 28px;
		font-size: 20px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: center;
		color: #333;
	}

	.exampleImgList {
		display: flex;
		justify-content: space-around;
	}

	.exampleImg {
		margin-right: 45px;
	}

	.exampleImg:nth-last-child(1) {
		margin-right: 0;
	}

	.exampleDate {
		margin-top: 30px;
		line-height: 22px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #bbb;
		padding-bottom: 30px;
		box-sizing: border-box;
		border-bottom: 1px solid #eee;
	}

	.example {
		width: 1040px;
		margin: 0 auto;
		overflow: hidden;
	}

	.exampleTitle {
		margin-top: 70px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
	}

	.localhostText {
		width: 1040px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
		margin: 0 auto;
	}

	.localhost {
		height: 85px;
		display: flex;
		align-items: center;
		background-color: #f6f7f7;
	}

	.localhostText {
		width: 1200px;
		margin: 0 auto;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
	}

	.title {
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Heavy;
		font-weight: 800;
		text-align: left;
		color: #333;
		margin-top: 60px;
	}

	.logo {
		width: 154px;
		height: 38px;
	}

	.navigation {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navigator {
		display: flex;
		align-items: center;
	}

	.navigatorText {
		line-height: 25px;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #fff;
		margin-left: 60px;
		cursor: pointer;
		transition: all .3s;
		position: relative;
	}

	.navigatorText:nth-child(1) {
		margin-left: 0px;
	}

	.navigatorText:hover {
		color: #EA5B24;
	}

	.block {
		position: absolute;
		/* width: 33px; */
		width: 100%;
		height: 2px;
		background-color: #fff;
		transition: all .3s;
		left: 0;
		bottom: -5px;
		opacity: 0;
	}

	.navigatorText:hover .block {
		background-color: #EA5B24;
		opacity: 1;
	}

	.navigationBg {
		width: 100%;
		background-color: rgba(0, 0, 0, 0.66);
		display: flex;
		justify-content: center;
		/* position: absolute;
		left: 0;
		top: 0; */
	}

	.navigatorText {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/pages/example01.vue